import { render, staticRenderFns } from "./ModalAttachQueue.vue?vue&type=template&id=4ba85edc&"
import script from "./ModalAttachQueue.vue?vue&type=script&lang=ts&"
export * from "./ModalAttachQueue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports